import { BusinessWithdrawTafificationAttributes } from "../attributes/business-withdraw-tafification-attributes";
import Currency from "./Currency";
import BaseModel from "./BaseModel";

class BusinessWithdrawTafification {
  id: number;
  min_amount: number;
  max_amount: number;
  commission_percentage: number;
  fees: number;

  currency: Currency;

  constructor(
    id: number,
    min_amount: number,
    max_amount: number,
    commission_percentage: number,
    fees: number,

    currency: Currency
  ) {
    this.id = id;
    this.min_amount = min_amount;
    this.max_amount = max_amount;
    this.commission_percentage = commission_percentage;
    this.fees = fees;
    this.currency = currency;
  }

  static fromJson(
    json: BusinessWithdrawTafificationAttributes
  ): BusinessWithdrawTafification | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new BusinessWithdrawTafification(
      json.id,
      json.min_amount,
      json.max_amount,
      json.commission_percentage,
      json.fees,
      json.currency != null ? Currency.fromJson(json.currency) : null
    );
  }
}

export default BusinessWithdrawTafification;
